export const INTEGRATION_PACK_TOOLS: Record<
  "calendly" | "squareup" | "cal",
  string[]
> = {
  calendly: ["get_slots", "get_booking_link"],
  squareup: [
    "list_products",
    "manage_cart",
    "checkout",
    "get_customer_order_history",
  ],
  cal: ["get_slots"],
};
